import { useReducer, useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  SET_LOADING: 'SET_LOADING',
  SET_ERROR: 'SET_ERROR',
  CLAER_STATE: 'CLAER_STATE',
  REQUEST_SUCCESS: 'REQUEST_SUCCESS',
  TRANSFER_SUCCESS: 'TRANSFER_SUCCESS',
}

const initialState = {
  code: undefined,
  refCode: undefined,
  expiresInMin: undefined,
  isLoading: false,
  error: undefined,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    case ActionType.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    case ActionType.REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        refCode: action.payload.ref,
        expiresInMin: action.payload.expiresInMin,
        error: undefined,
      }
    case ActionType.TRANSFER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: undefined,
        expiresInMin: undefined,
        code: undefined,
        refCode: undefined,
      }
    case ActionType.CLAER_STATE:
      return initialState
    default:
      return state
  }
}

export default function useOtp() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const dispatchSystem = useDispatch()
  const { formatMessage } = useIntl()

  const getOtp = useCallback(
    async (params) => {
      try {
        const response = await effects.apis.authV2.otpRequest({
          email: params.email,
          action: params.action,
        })

        return response
      } catch (error) {
        dispatchSystem(
          MessageAlert.showError({
            message: formatMessage({ id: 'teamMembers.otp.request.fail' }),
          }),
        )
        throw error
      }
    },
    [effects.apis.authV2, dispatchSystem, formatMessage],
  )

  const requestTransferAccount = useCallback(
    async (params) => {
      await effects.apis.authV2.transferAccount(params)
    },
    [effects.apis.authV2, dispatchSystem, formatMessage],
  )

  const requestOtp = async (params) => {
    dispatch({ type: ActionType.SET_LOADING, payload: true })
    const result = await getOtp(params)
    dispatch({ type: ActionType.REQUEST_SUCCESS, payload: result })
  }
  const reRequestOtp = async (params) => {
    const result = await getOtp(params)
    dispatch({ type: ActionType.REQUEST_SUCCESS, payload: result })
  }

  const clearStateOtp = () => {
    dispatch({ type: ActionType.CLAER_STATE })
  }

  const transferAccount = async (params) => {
    try {
      await requestTransferAccount(params)
      dispatch({ type: ActionType.TRANSFER_SUCCESS, payload: true })
      dispatchSystem(
        MessageAlert.showSuccess({
          message: formatMessage({
            id: 'teamMembers.transfer.success',
          }),
        }),
      )
      return true
    } catch (error) {
      dispatch({ type: ActionType.SET_ERROR, payload: true })
      throw error
    }
  }

  return {
    state,
    requestOtp,
    reRequestOtp,
    clearStateOtp,
    transferAccount,
  }
}
